<template>
  <div class="my-page-component">
    <div class="inner">
      <div v-if="!loggedIn" class="login">
        <Login @login="login" />
      </div>
      <div v-if="loggedIn">
        <div class="my-name">
          <h1>Välkommen {{user.name1}}!</h1>
          <p>Ditt kundnummer är: {{user.addrlid}}</p>
        </div>
        <div class="tab-buttons">
          <div @click="goToRouteWithName('my pages ' + 'journey')" :class="{'button--square': true, active: (activeTab === 'journey')}">
            <span>Mina bokningar</span>
          </div>
          <div @click="goToRouteWithName('my pages ' + 'bookings')" :class="{'button--square': true, active: (activeTab === 'bookings')}">
            <span>Tidigare</span>
          </div>
          <div @click="goToRouteWithName('my pages ' + 'details')" :class="{'button--square': true, active: (activeTab === 'details')}">
            <span>Mina uppgifter</span>
          </div>
          <div @click="goToRouteWithName('my pages ' + 'password')" :class="{'button--square': true, active: (activeTab === 'password')}">
            <span>Ändra lösenord</span>
          </div>
          <div @click="goToRouteWithName('my pages ' + 'logout')" :class="{'button--square': true, active: (activeTab === 'logout')}">
            <span>Logga ut</span>
          </div>
        </div>

        <div class="tab-wrapper">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';
import Login from '@/components/payments/Login';

export default {
  data() {
    return {
      orders: [],
      user: {},
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    activeTab() {
      return this.$route.meta.page;
    },
  },
  methods: {
    ...mapMutations([
      'setUser',
      'updateResetPasswordSuccessMessage',
    ]),
    goToRouteWithName(name) {
      this.$router.push({ name });
    },
    async fetch() {
      const { user, error } = await API.get('/account/user');
      if (user) {
        this.user = user;
      }

      if (error || !user) {
        this.setUser({
          token: null,
        });

        this.$emit('logout', true);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));

        this.$router.push({ name: 'login' });

        setTimeout(() => {
          window.location.reload();
        }, 200);
      }
    },
    login() {
      this.fetch();
      this.goToRouteWithName('my pages journey');
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
@import '~@/global-v2.styl'

.my-name
  color theme-blue
  text-align: center
  margin-bottom 3em
  h1
    big-title()
    color inherit
    text-transform none

.login
  padding 50px

.my-page-component
  background-color light-blue
  min-height 80vh
  padding-top 50px
  font-size 1rem

.tab-wrapper
  padding 20px 25px

.inner
  // background-color white
  max-width 900px
  margin 0 auto
  .tab-buttons
    display flex
    justify-content: center
    flex-wrap wrap
    & > *
      margin: 0.25em
      text-align: center
      @media (max-width: 650px)
        width calc(50% - 0.5em)

.icon-on-mobile
  display none
.icon-on-desktop
  display: inline-block
+max-mobile()
  .icon-on-mobile
    display inline-block
  .icon-on-desktop
    display: none
</style>



// WEBPACK FOOTER //
// MyPage.vue?dc31e5d6